"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EpubView;
var _react = _interopRequireWildcard(require("react"));
var _reactReader = require("react-reader");
var _core = require("@material-ui/core");
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
var _reactDetectOffline = require("react-detect-offline");
var _utils = require("../../utils");
var _lab = require("@material-ui/lab");
var _contexts = require("../../contexts");
var _NotePopover = _interopRequireDefault(require("../NotePopover"));
var _Footer = _interopRequireDefault(require("./Footer"));
var _LoadingView = _interopRequireDefault(require("./LoadingView"));
var _services = require("../../services");
var _styles = require("./styles");
var _themes = require("../../themes");
require("./styles.css");
var _CopyrightDialog = _interopRequireDefault(require("../CopyrightDialog"));
var _CopyTextDialog = _interopRequireDefault(require("../CopyTextDialog"));
var _CopyrightLimitDialog = _interopRequireDefault(require("../CopyrightLimitDialog"));
var _book = require("../../constants/book");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } /* eslint-disable */ // External Libraries
// Contexts
// Components
// Services
// Styles
function EpubView() {
  var {
    backgroundStyle,
    fontButton,
    setBackgroundStyle,
    setFontButton,
    setColumnType
  } = (0, _react.useContext)(_contexts.ReaderPreferencesContext);
  var [initialPage, setInitialPage] = (0, _react.useState)(0);
  var [isReaderReady, setIsReaderReady] = (0, _react.useState)(false);
  var [epubFetchFailed, setEpubFetchFailed] = (0, _react.useState)(false);
  var isDesktopView = (0, _core.useMediaQuery)('(min-width:769px)');
  var classes = (0, _styles.useStyles)();
  var alertClasses = (0, _styles.alertStyles)();
  var {
    uuid,
    epubFile,
    setRendition,
    setCurrentLocation,
    setCurrentEndLocation,
    setTotalLocation,
    setCurrentPercentage,
    bookTitle,
    cfi,
    setCfi,
    setChapters,
    userId,
    applicationToken,
    sessionToken,
    setOfflineMessage,
    showingOfflineMessage,
    setAppOffline,
    setEpubFile,
    setLoadingLocations,
    loadingLocations,
    rendition,
    jumpToPage,
    setOnlineMessage,
    showingOnlineMessage
  } = (0, _react.useContext)(_contexts.EpubReaderContext);
  var {
    setBookmarks
  } = (0, _react.useContext)(_contexts.BookmarksContext);
  var {
    setHighlights,
    selectTextRange,
    setHighlightsCallback,
    repaintHighlight
  } = (0, _react.useContext)(_contexts.HighlightsContext);
  var {
    snackBar
  } = (0, _react.useContext)(_contexts.SideBarContext);
  var appToken = (0, _utils.appTokenCase)(window.location.origin);
  var trackService = (0, _services.TrackingsService)(appToken, sessionToken);
  (0, _react.useEffect)(() => {
    if (loadingLocations) return;
    jumpToPage(initialPage);
    updateCurrentPage(initialPage);
  }, [loadingLocations]);
  (0, _react.useEffect)(() => {
    if (!epubFile || isReaderReady) return;
    var blockedKeys = new Set(['ArrowLeft', 'ArrowRight', 'PageUp', 'PageDown', 'Space']);
    var preventNavigationDuringLoading = event => {
      if (blockedKeys.has(event.code) || blockedKeys.has(event.key)) {
        event.preventDefault();
        event.stopPropagation();
      }
    };
    window.addEventListener('keydown', preventNavigationDuringLoading, true);
    return () => {
      window.removeEventListener('keydown', preventNavigationDuringLoading, true);
    };
  }, [epubFile, isReaderReady]);
  (0, _react.useEffect)(() => {
    var syncLastPage = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* () {
        try {
          var service = (0, _services.PagesService)(applicationToken, sessionToken);
          var response = yield service.getLastPage(uuid, userId);
          if (!response.ok) {
            var error = yield response.json();
            throw error;
          }
          var result = yield response.json();
          var currentPage = result.data.page;
          setInitialPage(currentPage);
        } catch (error) {
          console.error(error);
        }
      });
      return function syncLastPage() {
        return _ref.apply(this, arguments);
      };
    }();
    syncLastPage();
  }, []);
  (0, _react.useEffect)(() => {
    function fetchEpub() {
      return _fetchEpub.apply(this, arguments);
    }
    function _fetchEpub() {
      _fetchEpub = _asyncToGenerator(function* () {
        try {
          setIsReaderReady(false);
          var response = yield (0, _services.EpubService)(applicationToken, sessionToken).getEpubFile(uuid);
          if (!response.ok) {
            var errors = yield response.json();
            throw errors;
          }
          var file = yield response.blob();
          setEpubFile(file);
        } catch (err) {
          console.error('Failed to fetch EPUB:', err);
          setEpubFetchFailed(true);
        }
      });
      return _fetchEpub.apply(this, arguments);
    }
    fetchEpub();
  }, [applicationToken, uuid, sessionToken, setEpubFile]);
  var syncUserHighlights = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (rend) {
      try {
        var service = (0, _services.HighlightsService)(applicationToken, sessionToken);
        var response = yield service.listUserHighlights(uuid, userId);
        if (!response.ok) {
          var error = yield response.json();
          throw error;
        }
        var result = yield response.json();
        var parsedHighlights = result.data.map(highlight => ({
          id: highlight.id,
          annotation: highlight.annotation,
          textReference: highlight.text_reference,
          textHighlighted: highlight.text_highlighted,
          color: highlight.color
        }));
        setHighlights(parsedHighlights);
        parsedHighlights.forEach(highlight => {
          selectTextRange(rend, highlight.textReference, highlight.color);
        });
      } catch (error) {
        console.error(error);
        console.log('Não foi possível carregar os destaques.');
      }
    });
    return function syncUserHighlights(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var getSafeCurrentLocation = rend => {
    if (!rend || typeof rend.currentLocation !== 'function') return null;
    try {
      return rend.currentLocation() || null;
    } catch (error) {
      console.warn('Não foi possível obter currentLocation do rendition:', error);
      return null;
    }
  };
  var applyRenditionLayout = (rend, columns) => {
    if (!rend) return;
    try {
      if (columns === 'one') {
        rend.spread('none');
        rend.resize(680);
      } else {
        rend.spread('auto');
        rend.resize(1900);
      }
    } catch (error) {
      console.warn('Não foi possível aplicar layout no rendition:', error);
    }
  };
  var waitForStableRendition = function waitForStableRendition(rend) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1200;
    return new Promise(resolve => {
      if (!rend || typeof rend.on !== 'function') {
        resolve();
        return;
      }
      var settled = false;
      var finish = () => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        if (typeof rend.off === 'function') {
          rend.off('rendered', onRendered);
        }
        resolve();
      };
      var onRendered = () => finish();
      var timer = setTimeout(finish, timeout);
      rend.on('rendered', onRendered);
      try {
        var views = typeof rend.views === 'function' ? rend.views() : [];
        if (Array.isArray(views) && views.length > 0) {
          finish();
        }
      } catch (error) {
        console.warn('Não foi possível validar estado inicial do rendition:', error);
      }
    });
  };
  var syncUserPreferences = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(function* (rend) {
      try {
        var service = (0, _services.ReaderPreferencesService)(applicationToken, sessionToken);
        var response = yield service.getUserPreferences(userId);
        if (!response.ok) {
          var error = yield response.json();
          throw error;
        }
        var result = yield response.json();
        var {
          settings
        } = result.data;
        setBackgroundStyle(settings.background_style);
        setColumnType(settings.columns);
        setFontButton({
          fontSize: settings.font_size,
          fontPercentageValue: settings.font_size * 5
        });
        yield waitForStableRendition(rend);
        rend.themes.fontSize("".concat(settings.font_size, "px"));
        rend.themes.select(settings.background_style);
        applyRenditionLayout(rend, settings.columns);
      } catch (error) {
        console.error(error);
        console.log('Não foi possível carregar as preferências do usuário');
        try {
          applyRenditionLayout(rend, _themes.DEFAULT_PREFERENCES.columns);
          rend.themes.fontSize("".concat(_themes.DEFAULT_PREFERENCES.fontSize, "px"));
        } catch (fallbackError) {
          console.warn('Não foi possível aplicar preferências padrão:', fallbackError);
        }
      }
    });
    return function syncUserPreferences(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var syncUserBookmarks = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(function* () {
      try {
        var service = (0, _services.BookmarksService)(applicationToken, sessionToken);
        var response = yield service.listUserBookmarks(uuid, userId);
        if (!response.ok) {
          var error = yield response.json();
          throw error;
        }
        var result = yield response.json();
        var parsedBookmarks = result.data.map(bookmark => ({
          id: bookmark.id,
          cfi: bookmark.page_reference,
          chapterName: bookmark.chapter_name,
          summary: bookmark.summary
        }));
        setBookmarks(parsedBookmarks);
      } catch (error) {
        console.error(error);
        console.log('Não foi possível carregar as anotações do usuário.');
      }
    });
    return function syncUserBookmarks() {
      return _ref4.apply(this, arguments);
    };
  }();
  var generateLocations = rend => {
    var {
      book
    } = rend;
    var applyLocationState = _ref5 => {
      var {
        startLocation = 1,
        endLocation = startLocation,
        totalLocations = 1,
        percentage = 0,
        unlockLoading = false
      } = _ref5;
      setCurrentLocation(startLocation);
      setCurrentEndLocation(endLocation);
      setTotalLocation(totalLocations);
      setCurrentPercentage(percentage);
      if (unlockLoading) {
        setLoadingLocations(false);
      }
    };
    var applyFallbackLocationState = function applyFallbackLocationState() {
      var totalLocations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      applyLocationState({
        startLocation: 1,
        endLocation: 1,
        totalLocations,
        percentage: 0,
        unlockLoading: true
      });
    };
    if (!book) {
      console.warn('Book não está disponível para gerar localizações');
      applyFallbackLocationState();
      return;
    }
    book.ready.then(() => {
      var key = "".concat(book.key(), "-locations");
      var stored = localStorage.getItem(key);
      setLoadingLocations(true);
      if (stored) {
        return book.locations.load(stored);
      }

      // Or generate the locations on the fly
      // Can pass an option number of chars to break sections by
      // default is 150 chars
      return book.locations.generate(_book.CHARS_PER_PAGE);
    }).then(locations => {
      var totalLocations = (locations === null || locations === void 0 ? void 0 : locations.length) || 1;
      var initialLocationResolved = false;
      var fallbackTimeout = null;
      var setInitialFallbackState = () => {
        applyFallbackLocationState(totalLocations);
      };
      var updateCurrentLocation = () => {
        try {
          var _currentLocation$star, _currentLocation$end$, _currentLocation$end, _currentLocation$star2;
          if (!(book !== null && book !== void 0 && book.locations)) {
            return false;
          }
          var currentLocation = getSafeCurrentLocation(rend);
          var startLocation = currentLocation === null || currentLocation === void 0 || (_currentLocation$star = currentLocation.start) === null || _currentLocation$star === void 0 ? void 0 : _currentLocation$star.location;
          var endLocation = (_currentLocation$end$ = currentLocation === null || currentLocation === void 0 || (_currentLocation$end = currentLocation.end) === null || _currentLocation$end === void 0 ? void 0 : _currentLocation$end.location) !== null && _currentLocation$end$ !== void 0 ? _currentLocation$end$ : startLocation;
          var startCfi = currentLocation === null || currentLocation === void 0 || (_currentLocation$star2 = currentLocation.start) === null || _currentLocation$star2 === void 0 ? void 0 : _currentLocation$star2.cfi;
          if (startLocation === undefined) {
            return false;
          }
          var percentage = 0;
          if (startCfi) {
            var percent = book.locations.percentageFromCfi(startCfi);
            if (Number.isFinite(percent)) {
              percentage = Math.floor(percent * 100);
            }
          }
          applyLocationState({
            startLocation,
            endLocation: endLocation !== null && endLocation !== void 0 ? endLocation : startLocation,
            totalLocations,
            percentage,
            unlockLoading: true
          });
          return true;
        } catch (error) {
          console.warn('Erro ao calcular porcentagem da localização:', error);
          setInitialFallbackState();
          return true;
        }
      };
      if (!updateCurrentLocation()) {
        var handleRelocated = () => {
          if (updateCurrentLocation()) {
            initialLocationResolved = true;
            if (fallbackTimeout) clearTimeout(fallbackTimeout);
          }
          rend.off('relocated', handleRelocated);
        };
        rend.on('relocated', handleRelocated);
        fallbackTimeout = setTimeout(() => {
          if (initialLocationResolved) return;
          setInitialFallbackState();
          rend.off('relocated', handleRelocated);
        }, 4000);
      }
      rend.on('relocated', location => {
        var _location$start, _location$end;
        if (location.atEnd) {
          applyLocationState({
            startLocation: totalLocations,
            endLocation: totalLocations,
            totalLocations,
            percentage: 100
          });
        } else if (location !== null && location !== void 0 && (_location$start = location.start) !== null && _location$start !== void 0 && _location$start.cfi && (location === null || location === void 0 || (_location$end = location.end) === null || _location$end === void 0 ? void 0 : _location$end.location) !== undefined) {
          try {
            if (!(book !== null && book !== void 0 && book.locations)) {
              console.warn('book.locations não está disponível durante relocated');
              return;
            }
            var percent = book.locations.percentageFromCfi(location.start.cfi);
            var percentage = Math.floor(percent * 100);
            applyLocationState({
              startLocation: location.start.location,
              endLocation: location.end.location,
              totalLocations,
              percentage
            });
          } catch (error) {
            console.warn('Erro ao calcular porcentagem da localização relocada:', error);
          }
        }
      });
      localStorage.setItem("".concat(book.key(), "-locations"), book.locations.save());
    }).catch(error => {
      console.error(error);
      applyFallbackLocationState();
    });
  };
  var updateCurrentPage = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(function* (epubCfi) {
      try {
        var service = (0, _services.PagesService)(applicationToken, sessionToken);
        var response = yield service.updateCurrentPage(uuid, userId, {
          page: epubCfi
        });
        if (!response.ok) {
          var error = yield response.json();
          throw error;
        }
      } catch (error) {
        console.error(error);
      }
    });
    return function updateCurrentPage(_x3) {
      return _ref6.apply(this, arguments);
    };
  }();
  var trackingPageView = () => {
    try {
      var _currentLocation$star3;
      var currentLocation = getSafeCurrentLocation(rendition);
      var currentPage = (currentLocation === null || currentLocation === void 0 || (_currentLocation$star3 = currentLocation.start) === null || _currentLocation$star3 === void 0 ? void 0 : _currentLocation$star3.location) || 1;
      trackService.trackPageView({
        uuid,
        titleCover: bookTitle,
        sessionToken,
        fontSize: fontButton.fontPercentageValue,
        currentPage
      });
    } catch (error) {
      console.warn('Erro ao rastrear visualização da página:', error);
      // Fallback com valor padrão
      trackService.trackPageView({
        uuid,
        titleCover: bookTitle,
        sessionToken,
        fontSize: fontButton.fontPercentageValue,
        currentPage: 1
      });
    }
  };
  var disableRightClick = rend => {
    rend.on('rendered', (_, reader) => reader.document.documentElement.addEventListener('contextmenu', event => event.preventDefault()));
  };
  var createHighlightCallback = rend => {
    rend.on('rendered', (_, reader) => setHighlightsCallback(rend, reader));
  };
  var onResize = rend => {
    if ((0, _utils.getMobileOperatingSystem)() !== 'Android') return;
    var location;
    var justResized = false;
    var correcting = false;
    rend.on('relocated', () => {
      if (!justResized) {
        if (!correcting) {
          var _rend$location;
          location = ((_rend$location = rend.location) === null || _rend$location === void 0 || (_rend$location = _rend$location.end) === null || _rend$location === void 0 ? void 0 : _rend$location.cfi) || null;
        } else {
          correcting = false;
        }
      } else {
        setTimeout(() => {
          justResized = false;
          correcting = true;
          if (location) {
            rend.display(location);
          }
        }, 500);
      }
    });
    rend.on('resized', () => {
      justResized = true;
    });
  };

  // It fixes "No Section Found" for some books
  var getSpinePatching = rend => {
    var getSpineDefault = rend.book.spine.get.bind(rend.book.spine);
    rend.book.spine.get = function (target) {
      return getSpineDefault(target) || this.spineItems.find(item => item.idref.includes(target));
    };
  };

  // If next does not work go to next Section - Fix for section with linear = false
  var onNextPage = rend => {
    var nextDefault = rend.next.bind(rend);
    rend.next = /*#__PURE__*/_asyncToGenerator(function* () {
      var _currentLoc$start$cfi, _currentLoc$start, _newLoc$start$cfi, _newLoc$start;
      var currentLoc = getSafeCurrentLocation(this);
      var prevCfi = (_currentLoc$start$cfi = currentLoc === null || currentLoc === void 0 || (_currentLoc$start = currentLoc.start) === null || _currentLoc$start === void 0 ? void 0 : _currentLoc$start.cfi) !== null && _currentLoc$start$cfi !== void 0 ? _currentLoc$start$cfi : null;
      var response = yield nextDefault();
      var newLoc = getSafeCurrentLocation(this);
      var newCfi = (_newLoc$start$cfi = newLoc === null || newLoc === void 0 || (_newLoc$start = newLoc.start) === null || _newLoc$start === void 0 ? void 0 : _newLoc$start.cfi) !== null && _newLoc$start$cfi !== void 0 ? _newLoc$start$cfi : null;
      var nextIndex = newLoc !== null && newLoc !== void 0 && newLoc.start ? newLoc.start.index + 1 : 0;
      var maxIndex = this.book.spine.length - 1;
      if (prevCfi !== newCfi || nextIndex >= maxIndex) return response;
      return this.display(nextIndex);
    });
  };

  // If prev does not work go to prev Section - Fix for section with linear = false
  var onPreviousPage = rend => {
    var prevDefault = rend.prev.bind(rend);
    rend.prev = /*#__PURE__*/_asyncToGenerator(function* () {
      var _currentLoc$start$cfi2, _currentLoc$start2, _newLoc$start$cfi2, _newLoc$start2;
      var currentLoc = getSafeCurrentLocation(this);
      var prevCfi = (_currentLoc$start$cfi2 = currentLoc === null || currentLoc === void 0 || (_currentLoc$start2 = currentLoc.start) === null || _currentLoc$start2 === void 0 ? void 0 : _currentLoc$start2.cfi) !== null && _currentLoc$start$cfi2 !== void 0 ? _currentLoc$start$cfi2 : null;
      var response = yield prevDefault();
      var newLoc = getSafeCurrentLocation(this);
      var newCfi = (_newLoc$start$cfi2 = newLoc === null || newLoc === void 0 || (_newLoc$start2 = newLoc.start) === null || _newLoc$start2 === void 0 ? void 0 : _newLoc$start2.cfi) !== null && _newLoc$start$cfi2 !== void 0 ? _newLoc$start$cfi2 : null;
      var prevIndex = newLoc !== null && newLoc !== void 0 && newLoc.start ? newLoc.start.index - 1 : 0;
      if (prevCfi !== newCfi || prevIndex < 0) return response;
      return this.display(prevIndex);
    });
  };
  var onRenditionReady = rend => {
    if (rend) {
      getSpinePatching(rend);
      onNextPage(rend);
      onPreviousPage(rend);
      setRendition(rend);
      setIsReaderReady(true);
      generateLocations(rend);
      syncUserPreferences(rend).then(() => syncUserHighlights(rend)).catch(error => console.error(error));
      syncUserBookmarks();
      disableRightClick(rend);
      createHighlightCallback(rend);
      onResize(rend);
    }
  };
  if (!epubFile) {
    if (epubFetchFailed) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes.container
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.readerContainer
      }, /*#__PURE__*/_react.default.createElement(_lab.Alert, {
        severity: "error"
      }, "N\xE3o foi poss\xEDvel carregar o livro. Recarregue a p\xE1gina ou fa\xE7a login novamente.")));
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.readerContainer
    }, /*#__PURE__*/_react.default.createElement(_reactReader.ReactReader, {
      showToc: false,
      styles: (0, _styles.reactReaderStyles)(backgroundStyle, isDesktopView, epubFile, isReaderReady),
      epubViewStyles: _styles.epubViewStyles,
      loadingView: /*#__PURE__*/_react.default.createElement(_LoadingView.default, null)
    }), /*#__PURE__*/_react.default.createElement(_core.Hidden, {
      xsDown: true
    }, /*#__PURE__*/_react.default.createElement(_Footer.default, null))));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactDetectOffline.Detector, {
    polling: {
      url: 'https://ipv4.icanhazip.com'
    },
    onChange: isOnline => {
      if (isOnline) {
        setOnlineMessage(true);
        setOfflineMessage(false);
        setAppOffline(false);
        localStorage.removeItem('isAppOffline');
      } else {
        setOnlineMessage(false);
        setOfflineMessage(true);
        setAppOffline(true);
        localStorage.setItem('isAppOffline', true);
      }
    },
    render: _ref9 => {
      var {
        online
      } = _ref9;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !online && showingOfflineMessage && /*#__PURE__*/_react.default.createElement(_lab.Alert, {
        classes: alertClasses,
        severity: "error"
      }, "Voc\xEA est\xE1 sem internet no momento. Continue sua leitura tranquilamente, apenas n\xE3o recarregue ou feche o navegador."), /*#__PURE__*/_react.default.createElement(_saraivaUi.Snackbar, {
        classes: _styles.snackBarStyles,
        show: online && showingOnlineMessage,
        severity: "success",
        autoHideDuration: 5000,
        handleClose: () => setOnlineMessage(false)
      }, "Eba! Sua internet est\xE1 dispon\xEDvel novamente."), snackBar && isDesktopView && /*#__PURE__*/_react.default.createElement("div", {
        className: classes.snackBar
      }, /*#__PURE__*/_react.default.createElement(_saraivaUi.Snackbar, {
        severity: "success",
        noClose: true,
        show: snackBar
      }, "Refer\xEAncia bibliogr\xE1fica copiada para \xE1rea de transfer\xEAncia.")));
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.readerContainer
  }, /*#__PURE__*/_react.default.createElement(_reactReader.ReactReader, {
    url: epubFile,
    location: cfi,
    locationChanged: epubCfi => {
      setCfi(epubCfi);
      updateCurrentPage(epubCfi);
      trackingPageView();
      repaintHighlight(rendition);
    },
    getRendition: rend => {
      onRenditionReady(rend);
    },
    tocChanged: toc => {
      setChapters(toc);
    },
    showToc: false,
    styles: (0, _styles.reactReaderStyles)(backgroundStyle, isDesktopView, epubFile, isReaderReady),
    epubViewStyles: _styles.epubViewStyles,
    loadingView: /*#__PURE__*/_react.default.createElement(_LoadingView.default, null)
  }), !isReaderReady && /*#__PURE__*/_react.default.createElement("div", {
    "aria-hidden": true,
    style: {
      position: 'absolute',
      inset: 0,
      zIndex: 10
    }
  }), /*#__PURE__*/_react.default.createElement(_NotePopover.default, null), /*#__PURE__*/_react.default.createElement(_CopyrightDialog.default, null), /*#__PURE__*/_react.default.createElement(_CopyTextDialog.default, null), /*#__PURE__*/_react.default.createElement(_CopyrightLimitDialog.default, null), /*#__PURE__*/_react.default.createElement(_core.Hidden, {
    xsDown: true
  }, /*#__PURE__*/_react.default.createElement(_Footer.default, null)))));
}